import 'rxjs/add/operator/map';
import 'rxjs/Rx';

import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { AppMessage } from '../../Common/appMessage';
import { AppGlobals } from '../../Common/Services/app.global';
import { SharedService } from '../../Common/Services/shared.service';
import { Utility } from '../../Common/Services/utility';
import { AppConfig } from './../../Common/appConfiguration';
import { AdmManageChatIdleTimeService } from './adm-manage-chat-idle-time.service';
import { FeatureFlagService, ToggleName } from 'app/Common/Services/feature-flag.service';


@Component({
  selector: 'app-adm-manage-chat-idle-time',
  templateUrl: './adm-manage-chat-idle-time.component.html',
  styleUrls: ['./adm-manage-chat-idle-time.component.css'],
  providers: [AdmManageChatIdleTimeService, FeatureFlagService]
})
export class AdmManageChatIdleTimeComponent implements OnInit, OnDestroy {

  form: FormGroup;
  isUpdateBtnDisable: boolean = true;
  constructor(private featureFlags: FeatureFlagService, private chatService: AdmManageChatIdleTimeService, private _utility: Utility, private _appMessage: AppMessage) {
    this.form = new FormGroup({
      chatIdleTime: new FormControl(0, [Validators.required, Validators.pattern(AppConfig.onlyNumericRegEx)])
    });
  }

  private redirect(): void {
    window.location.assign("/ies/internal/manage-chat-idle-time");
  }

  ngOnInit() {
    this.featureFlags.on("ready", () => {
      if (this.featureFlags.isEnabled(ToggleName.ENABLE_MANAGE_CHAT_IDLE_TIME_REDIRECT)) {
        this.redirect();
      }
    });
    this.featureFlags.on("update", () => {
      if (this.featureFlags.isEnabled(ToggleName.ENABLE_MANAGE_CHAT_IDLE_TIME_REDIRECT)) {
        this.redirect();
      }
    });
    this.featureFlags.start();
    this.getChatTimeData();
    // Whether the form data are modified or not
    this.form.valueChanges
      .subscribe(form => {
        if (!this.form.disabled && this.form.dirty) {
          this._utility.setTxnStatus(true);
        }
      });
  }

  ngOnDestroy(): void {
      this.featureFlags.stop();
  }

  // Called Method, once click on the Update button to update the data. Also this method will call the method updatePolicy(params: any) to connect API.
  onUpdateForm(): void {
    this._utility.addLoaderCount();
    this.chatService.updateChatTime(this.form.getRawValue())
      .subscribe(data => {
        this._utility.onSuccessCallback(data, this._appMessage.getItem['UMsg00091'], () => {
          this.isUpdateBtnDisable = true;
          this._utility.disableEnableForm(this.form, true);
          this._utility.clearTxnStatus(); // close confirm box for FORM changes
        });
      },
        error => this._utility.onErrorCallback(error));
  }

  getChatTimeData(): any {
    this._utility.addLoaderCount();
    this.chatService.getChatTime()
      .subscribe(
        (response: any) => {
          this._utility.onSuccessCallback(response, null, () => {
            if (response && response.response) {
              let data = response.response;
              this.form.patchValue(data);
              this._utility.disableEnableForm(this.form, true);
            }
          });
        },
        error => {
          this._utility.onErrorCallback(error);
        });
  }

  onEdit() {
    this._utility.disableEnableForm(this.form, false);
    this.isUpdateBtnDisable = false;
  }


}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-manage-chat-idle-time/adm-manage-chat-idle-time.component.ts